import angular from 'angular';
import { find, get, set } from 'lodash';
import '../../services/organization';
import '../../services/user';
import '../../services/place';

const module = angular.module('whyline.modals.appointment-info', [
  'whyline.services.organization',
  'whyline.services.place',
  'whyline.services.user',
]);

 const AppointmentInfoController = ($scope, $uibModalInstance, $translate, appointment, OrganizationService, PlaceService, UserService) => {
  'ngInject';

  $scope.appointment = appointment;
  $scope.customFields = [];
  $scope.place = PlaceService.GetCurrent();
  $scope.hasToHidePersonalDataFields = UserService.HasToHidePersonalDataFields($scope.place._id);

  const init = () => {
    getCustomFields();
  };

   // Close modal
  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  const getCustomFields = () => {
    const fields = get($scope, 'appointment.person.customFields', {});
    set($scope, 'appointment.person.customFields', fields);

    OrganizationService.GetCustomFields($scope.place.organizationId)
      .then((customFields) => {
        $scope.customFields = customFields;
      })  
      .catch(() => {})
  }

  $scope.getCustomFieldValue = (key, value) => {
    const result = find($scope.customFields, (field) => field.name === key);
    if (result.type === 'boolean') {
      return value ? $translate.instant('yes') : $translate.instant('no');
    }
    return value;
  }

  init();
};

module.exports = module.controller('AppointmentInfoController', AppointmentInfoController);
